import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { PaymentStatusTab, IPaymentStatusState } from "./PaymentStatusType";

export const initialState: IPaymentStatusState = {
  currentTab: PaymentStatusTab.Payments,
};

const paymentStatusSlice = createSlice({
  name: "PaymentStatus",
  initialState,
  reducers: {
    setCurrentTab(state: IPaymentStatusState, action: PayloadAction<PaymentStatusTab>) {
      return { currentTab: action.payload };
    },
  },
});

export const {setCurrentTab} = paymentStatusSlice.actions;
export default paymentStatusSlice.reducer;